export const routes = {
  BestOfRingFeed: '/',
  BestOfRingVideoFullscreen: '/:id_video',
  RingHistory: '/select-video',
};
